import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { hasAnyRole } from '../lib/roles'
import type { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
  requiredRole?: string[]
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { user, loading, userRoles } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (requiredRole && !hasAnyRole(userRoles, requiredRole)) {
    return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">403</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">Forbidden - Insufficient permissions</p>
          <a href="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">
            Go to Dashboard
          </a>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default ProtectedRoute
